var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitPullRequest = function SvgGitPullRequest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.156 5.017a2.827 2.827 0 0 1 2.826 2.826v6.598a3.866 3.866 0 1 1-1.496 0V7.843a1.33 1.33 0 0 0-1.33-1.33h-3.117a.748.748 0 1 1 0-1.496zM5.766 1.901a3.866 3.866 0 0 1 .747 7.656V21.35a.748.748 0 1 1-1.496 0V9.557a3.865 3.865 0 0 1 .75-7.656m12.468 13.964a2.37 2.37 0 1 0 0 4.738 2.37 2.37 0 0 0 0-4.738M5.766 3.397a2.37 2.37 0 0 0-.01 4.737h.019a2.37 2.37 0 0 0-.009-4.737"
  })));
};
export default SvgGitPullRequest;